import type { PickupOptionsProps } from '@/Pages/BuyNowPage/PaymentAndShipping/partials/PickupOptions/interfaces';
import { PickupOptionList } from '@/Pages/BuyNowPage/PaymentAndShipping/partials/PickupOptions/PickupOptionList';
import { PickupPerson } from '@/Pages/BuyNowPage/PaymentAndShipping/partials/PickupOptions/PickupPerson';
import { TitleContainer } from '@/Pages/BuyNowPage/PaymentAndShipping/partials/PickupOptions/TitleContainer';

export const PickupOptions = (props: PickupOptionsProps) => {
  const { id } = props;

  return (
    <section
      className="co-flex co-flex-col co-w-full"
      data-testid="co-pickup-select"
    >
      <TitleContainer />
      <PickupOptionList {...props} />

      <PickupPerson deliveryGroupId={id} />
    </section>
  );
};

PickupOptions.displayName = 'PickupOptions';

export default PickupOptions;
